import { render, staticRenderFns } from "./ProjectWeddingEvents.vue?vue&type=template&id=6d68f663"
import script from "./ProjectWeddingEvents.vue?vue&type=script&lang=ts"
export * from "./ProjectWeddingEvents.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports